import { render, staticRenderFns } from "./NavDownloadedOptions.vue?vue&type=template&id=bf923434&scoped=true"
import script from "./NavDownloadedOptions.vue?vue&type=script&lang=js"
export * from "./NavDownloadedOptions.vue?vue&type=script&lang=js"
import style0 from "./NavDownloadedOptions.vue?vue&type=style&index=0&id=bf923434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf923434",
  null
  
)

export default component.exports